import { FormlyFieldConfig } from "@ngx-formly/core";
import { FormlyValidationType } from "./formly-validation-type";


export class FormlyValidationMessage {

    static requiredMessage(error: any, field: FormlyFieldConfig) {
        return error['isTable'] ?? false ? 'Obligatori' : 'Aquest camp és requerit'
    }

    static matDatepickerParseMessage(error: any, field: FormlyFieldConfig) {
        return error['isTable'] ?? false ? 'dd/MM/yyyy' : 'Format incorrecte. exemple: dd/MM/yyyy'
    }

    static emailMessage(error: any, field: FormlyFieldConfig) {
        return error['isTable'] ?? false ? 'Correu incorrecte' : 'El format del correu no es correcte'
    }

}

export const FormlyValidationsMessages = [
    { name: FormlyValidationType.required, message: FormlyValidationMessage.requiredMessage },
    { name: FormlyValidationType.matDatepickerParse, message: FormlyValidationMessage.matDatepickerParseMessage },
    { name: FormlyValidationType.email, message: FormlyValidationMessage.emailMessage }
]